// extracted by mini-css-extract-plugin
export default {"section_ig":"Navigation__section_ig--ig-YpsdC","sticky_ig":"Navigation__sticky_ig--ig-ojfkR"};